import { RowProductListOrderType } from "@/view/product/product"
import Image from "next/image"
import Link from "next/link"
import { PersianNum } from "../tools/PersianNum"

const CardProduct = ({ data }: { data: RowProductListOrderType }) => {
    const discount = data.Warehouses[0]?.warehouse_discount || 0
    const price = data.Warehouses[0]?.warehouse_price || 0
    return (
        <div className="h-[350px] rounded text-center mx-auto relative ">
            <div className="h-[250px] w-[250px] mx-auto overflow-hidden ">
                <Link href={`/product/${data.product_url.replace(/ /g, "-")}`}>
                    <div className="aspect-w-1 aspect-h-1">
                        <Image
                            alt={data.product_image_alt}
                            src={process.env.imageUrl + data.product_image}
                            fill
                            className="object-cover rounded-md"
                            priority
                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcvOVYPQAGfQKOiuBnlQAAAABJRU5ErkJggg=="
                            placeholder="blur"
                        />
                    </div>
                </Link>
            </div>
            <div className="p-1 w-[90%] bg-purple-100 dark:bg-slate-600 absolute bottom-4 left-1/2 transform -translate-x-1/2 shadow-lg rounded bg-opacity-75 dark:bg-opacity-75">
                <div className="px-1">
                    <p className="text-lg truncate">{data.product_title}</p>
                    {/* <p className="text-sm truncate">{data.product_title_second}</p> */}
                </div>
                {
                    discount ?
                        <div className="flex justify-between items-center px-1">
                            <p className="font-bold p-1 text-red-700">{PersianNum(discount)}<span className="mx-1">تومان</span></p>
                            <p className="line-through  p-1">{PersianNum(price)}<span className="mx-1">تومان</span></p>
                        </div>
                        :
                        <div className="flex justify-between items-center px-1">
                            <p className="font-bold p-1">{PersianNum(price)} <span className="">تومان</span></p>
                        </div>
                }
            </div>
        </div>
    )
}

export default CardProduct